import AnalyticsIcon from '@mui/icons-material/Analytics';
import { MonthlyRecapPage } from './MonthlyRecapPage';

export default {
    list: MonthlyRecapPage,
    icon: AnalyticsIcon,
    options: { label: 'Analytics' },
};

